const menu = [
    {
      id: 1,
      category: 'OS',
      img: './imagesProjet/cert_linux.png',
    },
    {
      id: 2,
      category: 'Web',
      img: './imagesProjet/cert_css.png',
    },
    {
      id: 3,
      category: 'Cybersécurité',
      img: './imagesProjet/cert_cybersecurite.png',
    },
    {
      id: 4,
      category: 'Web',
      img: './imagesProjet/cert_html.png',
    },
    {
      id: 5,
      category: 'BDD',
      img: './imagesProjet/cert_sql.png',
    },
    {
      id: 6,
      category: 'BDD',
      img: './imagesProjet/cert_postgresql.PNG',
    },
    {
      id: 7,
      category: 'BDD',
      img: './imagesProjet/cert_sqlManipuleData.PNG',
    },
    {
      id: 8,
      category: 'Web',
      img: './imagesProjet/cert_php.PNG',
    },
    {
      id: 9,
      category: 'Web',
      img: './imagesProjet/cert_boostrap.PNG',
    },
    {
      id: 10,
      category: 'Mobile',
      img: './imagesProjet/cert_andoid.PNG',
    },
    {
      id: 11,
      category: 'OS',
      img: './imagesProjet/cert_bash_script.PNG',
    },
    {
      id: 12,
      category: 'Web',
      img: './imagesProjet/cert_javascript_app.PNG',
    },
    {
      id: 13,
      category: 'Web',
      img: './imagesProjet/cert_react.PNG',
    },
    {
      id: 14,
      category: 'Web',
      img: './imagesProjet/cert_react_front_app.PNG',
    },
    {
      id: 15,
      category: 'Web',
      img: './imagesProjet/cert_react_redux_app.PNG',
    },
    {
      id: 16,
      category: 'Web',
      img: './imagesProjet/cert_react_router.PNG',
    },
  ];
  export default menu;